import { createContext, useContext, useReducer } from 'react'

const FilterContext = createContext()
const FilterUpdateContext = createContext()

export const UPDATE_SELECTED_TEAM = 'UPDATE_SELECTED_TEAM'

export const UPDATE_SELECTED_DATE = 'UPDATE_SELECTED_DATE'

export const UPDATE_SELECTED_PLAYER = 'UPDATE_SELECTED_PLAYER'

const LOCAL_STORAGE_KEY = 'filterOptions'

const reducer = (state, action) => {
  const newState = getNewState(state, action)
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newState))
  return newState
}

const getNewState = (state, action) => {
  switch (action.type) {
    case UPDATE_SELECTED_TEAM:
      return {
        ...state,
        selectedTeamId: action.payload
      }
    case UPDATE_SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.payload
      }
    case UPDATE_SELECTED_PLAYER:
      return {
        ...state,
        selectedPlayerId: action.payload
      }
    default:
      console.log(`unrecognised action ${action}`)
      return state
  }
}

export const useFilter = () => useContext(FilterContext)

export const useFilterUpdate = () => useContext(FilterUpdateContext)

export const FilterProvider = ({ children }) => {
  const [appliedFilters, dispatch] = useReducer(
    reducer,
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {}
  )

  return (
    <FilterContext.Provider value={appliedFilters}>
      <FilterUpdateContext.Provider value={dispatch}>
        {children}
      </FilterUpdateContext.Provider>
    </FilterContext.Provider>
  )
}
